import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginationData } from '@ngneat/elf-pagination';
import { Observable, tap } from 'rxjs';
import { SortState } from '../modules/shared/pipes/sort.pipe';
import {
  BaseService,
  DEFAULT_ENTITIES_PER_PAGE,
} from './abstract/base.service';

import {
  ICompanyLocation,
  ICompanyMarker,
  IContact,
  IMapInfo,
} from './companies.repository';
import { LocationsRepository } from './locations.repository';

const API = '/api/companyLocations';

@Injectable({ providedIn: 'root' })
export class LocationsService extends BaseService<ICompanyLocation> {
  constructor(http: HttpClient, repo: LocationsRepository) {
    super(API, http, repo);
  }

  loadOneLocation(id: string) {
    return this.http.get<ICompanyLocation>(API + '/loadOneLocation/' + id);
  }

  postLocation(contact: Partial<IContact>) {
    return this.http.post<ICompanyLocation>(API + '/postLocation', contact);
  }

  updateLocation(contact: Partial<IContact>) {
    return this.http.put<ICompanyLocation>(API + '/updateLocation', contact);
  }
  loadPageCustom(
    page: number,
    take: number = DEFAULT_ENTITIES_PER_PAGE,
    search: string = '',
    clientId = ''
  ): Observable<PaginationData & { data: ICompanyLocation[] }> {
    const sortOrder = this.repo.getSort();
    const query = [
      `page=${page}`,
      `take=${take}`,
      `sort=${sortOrder.parameter.property}`,
      `direction=${sortOrder.direction}`,
      `search=${search}`,
      `clientId=${clientId}`,
    ];
    this.repo.setPage(page);
    return this.http
      .get<PaginationData & { data: ICompanyLocation[] }>(
        `${API}/customLoadPage/?${query.join('&')}`
      )
      .pipe(
        tap((res) => this.repo.addPage(res)),
        this.repo.track(),
        this.repo.skipWhilePageCached(page)
      );
  }

  sortCustom(sortBy: SortState, search?: string, clientId = '') {
    this.repo.setSort(sortBy);
    return this.reloadPageCustom(search, DEFAULT_ENTITIES_PER_PAGE, clientId);
  }

  reloadPageCustom(
    search: string = '',
    defaultTake: number = DEFAULT_ENTITIES_PER_PAGE,
    clientId = ''
  ): Observable<(PaginationData & { data: ICompanyLocation[] }) | null> {
    const data = this.repo.getPaginationData();
    if (data && Object.keys(data.pages).length) {
      this.repo.clearPages();
      return this.loadPageCustom(
        data.currentPage,
        data.perPage,
        search,
        clientId
      );
    }
    return this.loadPageCustom(1, defaultTake, search, clientId);
  }

  searchRelodePageCustom(
    search: string = '',
    defaultTake: number = DEFAULT_ENTITIES_PER_PAGE,
    clientId = ''
  ): Observable<(PaginationData & { data: ICompanyLocation[] }) | null> {
    const data = this.repo.getPaginationData();
    if (data && Object.keys(data.pages).length) {
      this.repo.clearPages();
      return this.loadPageCustom(1, data.perPage, search, clientId);
    }
    return this.loadPageCustom(1, defaultTake, search, clientId);
  }
}
